import { useCallback, useContext, useMemo } from 'react'
import { AuthenticationContext } from '../Auth/authentication.context'
import {
  TABLE_ROWS_PER_PAGE_OPTIONS,
  normalizeTableRows,
} from '../shared/tablePagination'

export const useTableRowsPerPage = (allowedOptions = TABLE_ROWS_PER_PAGE_OPTIONS) => {
  const { user, saveTableRowsPerPage } = useContext(AuthenticationContext)

  const defaultRows = useMemo(
    () => normalizeTableRows(user?.tableRowsPerPage, allowedOptions),
    [user?.tableRowsPerPage, allowedOptions]
  )

  const rowsPerPageOptions = allowedOptions

  const applyPageEvent = useCallback(
    (previousState, event) => {
      const prevRows = previousState?.rows ?? defaultRows
      const normalizedRows =
        event?.rows != null
          ? normalizeTableRows(event.rows, allowedOptions)
          : prevRows

      if (
        event?.rows != null &&
        normalizedRows !== prevRows &&
        saveTableRowsPerPage
      ) {
        saveTableRowsPerPage(normalizedRows)
      }

      return {
        ...previousState,
        ...event,
        first: event?.first ?? previousState?.first ?? 0,
        page: event?.page ?? previousState?.page ?? 0,
        rows: normalizedRows,
      }
    },
    [allowedOptions, defaultRows, saveTableRowsPerPage]
  )

  return {
    defaultRows,
    rowsPerPageOptions,
    applyPageEvent,
  }
}

export default useTableRowsPerPage
